import { Box, BoxProps } from '@primer/react';
import { Helmet } from 'react-helmet';
import { useCommonContext } from '../../../contexts/common';
import { useWindowSize } from '../../../hooks/useWindowSize';

export interface IPageProps extends Omit<BoxProps, 'height'> {
    height?: number
    title?: string
}
const Page = (props: IPageProps) => {
    const { height } = useWindowSize();
    const { translate } = useCommonContext();
    return (
        <>
            <Helmet>
                <title>{translate(props.title)}</title>
            </Helmet>
            <Box sx={{
                p: 3,
                backgroundColor: "#fff",
                // backgroundColor: "red",
                minHeight: height - 100,
                height: height-100,
                overflow: "auto",
                borderRadius: 2,
                ...props.sx
            }}>
                {props.children}
            </Box>
        </>
    );
};

export default Page;